import styled from "styled-components";

export const WuKongBannerStyle = styled.div`
  @font-face {
    font-family: "SourceHanSerifCN";
    src: url("https://cdn.ggac.com/v2/fonts/SourceHanSerifCN-Regular.85b46b6b.otf");
  }

  @font-face {
    font-family: "alibabaPuHuiTi";
    src: url("https://cdn.ggac.com/fonts/Alibaba-PuHuiTi-Medium.otf");
  }

  @font-face {
    font-family: "baigetianxingti";
    src: url("https://cdn.ggac.com/fonts/zihun50hao-baigetianxingti.ttf");
  }
  overflow-x: hidden;
  position: relative;
  .banner-img {
    width: 100%;
    min-width: 1200px;
  }
  .tab {
    width: 72vw;
    height: 4.3vw;
    min-width: 900px;
    min-height: 50px;
    position: absolute;
    bottom: 0.5vw;
    background: url("https://cdn.ggac.com/img/wukong-pc-kv-tag.png") center
      center no-repeat;
    background-size: 100% 100%;
    left: 50%;
    transform: translateX(-50%);
    font-family: "SourceHanSerifCN";
    display: flex;
    align-items: center;
    justify-content: space-around;
    &-item {
      color: #fff;
      flex: 1;
      height: 100%;
      font-size: 30px;
      text-align: center;
      height: 100%;
      line-height: 3.8vw;
      position: relative;
      z-index: 2;
      letter-spacing: 1px;
      cursor: pointer;
    }
  }
  .tab-item:hover,
  .active {
    color: #a93c1d;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background: url("https://cdn.ggac.com/img/wukong-pc-kv-tag-active.png")
        center center no-repeat;
      background-size: 100% 100%;
      width: 163px;
      height: 10px;
      bottom: 13px;
    }
  }
  .tip {
    position: absolute;
    font-size: 22px;
    color: #ffffff;
    text-align: center;
    margin-top: 10px;
    font-size: 1.2vw;
    left: 50%;
    transform: translateX(-50%);
    bottom: 160px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  .btn {
    position: absolute;
    bottom: 200px;
    left: 50%;
    transform: translateX(-50%);
    background: url("https://cdn.ggac.com/img/wukong-pc-kv-btn.png") center
      center no-repeat;
    width: 288px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    color: #5d370c;
    font-size: 27px;
    letter-spacing: 4px;
    padding-right: 30px;
    cursor: pointer;
  }
`;
